import { Injectable } from '@angular/core'
import {
  CanActivate, ActivatedRouteSnapshot,
  RouterStateSnapshot, CanActivateChild } from '@angular/router'
import { Observable } from 'rxjs'

import { environment } from 'environments/environment'
import { QueryString } from 'app/models'

@Injectable({
  providedIn: 'root'
})
export class PersonaGuardService implements CanActivate, CanActivateChild {

  constructor() { }

  public canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      this.navigateTo(this.redirectUrl(state))
      observer.next(true)
      observer.complete()
    })
  }

  public canActivateChild(route: ActivatedRouteSnapshot,
                          state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(route, state)
  }

  private redirectUrl(state: RouterStateSnapshot): string {
    const queryParams: any = {
      returnApp: 'memberships',
      returnPath: state.url.split('?')[0]
    }
    return environment.householdSetupUrl + '/setup/membership?' + QueryString.build(queryParams)
  }

  private navigateTo(url: string): void {
    window.location.assign(url)
  }

}
